import axios from 'axios';

const isFloor = import.meta.env['VITE_IS_FLOOR'];
const boothOrFloorPrefix = isFloor ? `elva-floor` : `elva-booth`;

export const USER_AUTH_STATE_STORAGE_KEY = `${boothOrFloorPrefix}.user.auth`;

const GLOBAL_API_URL = import.meta.env['VITE_PUBLIC_API_URL'];
if (!GLOBAL_API_URL) {
    throw new Error('No GLOBAL_API_URL found in .env');
}

export class ApiConfig {
    private static __globalEndpoint = new URL(GLOBAL_API_URL);
    private static __boothEndpoint: URL | null = null;

    static get baseUrl(): URL {
        return this.__boothEndpoint || this.__globalEndpoint;
    }
    static set baseUrl(url: string | undefined) {
        if (!url) {
            this.clear();
            return;
        }
        this.__boothEndpoint = new URL('https://' + url.replace(/^https?:\/\//, ''));
    }

    static get isBooth() {
        return !!this.__boothEndpoint && this.__boothEndpoint?.toString() !== this.__globalEndpoint.toString();
    }
    static clear() {
        this.__boothEndpoint = null;
    }
    static path(pathname: string) {
        return new URL(pathname, this.baseUrl).href;
    }
    static wsPath(pathname: string) {
        const url = new URL(pathname, this.baseUrl);
        url.protocol = url.protocol === 'http:' ? 'ws:' : 'wss:';
        return url.href;
    }
}

export const apiClient = axios.create({
    paramsSerializer: {
        indexes: null,
    },
});

function getAccessTokenFromLocalStorage(): string | null {
    const raw = localStorage.getItem(USER_AUTH_STATE_STORAGE_KEY);
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        return parsed?.access_token ?? null;
    } catch {
        return null;
    }
}

apiClient.interceptors.request.use(async (config) => {
    const token = getAccessTokenFromLocalStorage();
    if (token) {
        config.headers.set('Authorization', `Bearer ${token}`);
    }

    return config;
});
